<template>
  <generic-modal :title="$t('project')" :buttons="buttons" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("customer") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.customer"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("type") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.type">
                  <option value="project">{{ $t("project") }}</option>
                  <option value="revision">{{ $t("revision") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("status") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.status">
                  <option value="draft">{{ $t("draft") }}</option>
                  <option value="done">{{ $t("done") }}</option>
                  <option value="wait_payment">
                    {{ $t("waiting for payment") }}
                  </option>
                  <option value="paid">{{ $t("paid") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("advisor") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.advisor"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p>{{ error }}</p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CreateProjectModal",
  components: { GenericModal },
  data() {
    return {
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.type || !v.meta.status;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(project_uuid) {
      let v = this;
      v.set_initial_state();

      if (project_uuid) {
        // v.uuid = product_uuid;
        get("/air_project", { uuid: project_uuid })
          .then((project) => {
            v.meta = project;
            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/air_project", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/air_project", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          customer: "",
        },
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
